import React from "react";

const ReleaseV3 = () => {
  return (
    <div className="release_content">
      <h3>Beta v1.1.0</h3>
      <p>Released on 27 June 2023</p>

      <h2>Landing Page Enhacements</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>Responsive Mobile View Layout</span>
        </li>
      </ul>

      <h2>Individual Dataset Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            We have removed read only mode & introduced editable actions to
            dataset description,User can be able to edit and save it
          </span>
        </li>
        <li>
          <span>
            Dataset popup will now have Certified Details as editable where user
            can be able to edit the Certified By and Certified Date based on the
            toggle button
          </span>
        </li>
        <li>
          <span>
            Data Lineage Tab is Introduced to show the lineage on the Dataset
          </span>
        </li>
      </ul>
      <h2>View All Datasets Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            A toogle button is introduced which on clicking will list down all
            the datasets certified
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ReleaseV3;
